import eachDeep from 'deepdash/eachDeep';

const getMaxDepthOfTree = (rootNode, property) => {
  let maxDepth = 0;
  eachDeep(
    rootNode,
    (child, i, parent, ctx) => {
      if (maxDepth < ctx.depth) {
        maxDepth = ctx.depth;
      }
    },
    { childrenPath: property }
  );
  return maxDepth;
};

export default getMaxDepthOfTree;
